export class AdjustmentCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async editCriteria(body) {
    return this.#http.put(`/api/adjustment-criteria/${body.criteriaId}`, body);
  }

  async deleteCriteria({ criteriaId }) {
    return this.#http.delete(`/api/adjustment-criteria/${criteriaId}`);
  }

  async getCriteria(params) {
    return this.#http.get('/api/adjustment-criteria', { params });
  }

  async createCriteria(body) {
    return this.#http.post('/api/adjustment-criteria', body);
  }
}
